import styles from "./FollowToast.module.css";

export interface FollowNotice {
  id: number;
  tone: "success" | "error";
  message: string;
}

interface FollowToastProps {
  notice: FollowNotice | null;
  onDismiss: () => void;
}

/**
 * Confirmation or failure for a follow write. Failures are assertive (role="alert") because
 * the toggle has already rolled back; confirmations are polite.
 */
export default function FollowToast({ notice, onDismiss }: FollowToastProps) {
  if (!notice) return null;
  const isError = notice.tone === "error";
  return (
    <div
      key={notice.id}
      role={isError ? "alert" : "status"}
      aria-live={isError ? "assertive" : "polite"}
      className={isError ? styles.error : styles.success}
    >
      <span>{notice.message}</span>
      <button type="button" className={styles.dismiss} onClick={onDismiss}>
        Dismiss
      </button>
    </div>
  );
}
